import CardContent from "./CardContent.jsx";

export default function TeaserContent(props) {
  // eslint-disable-next-line no-console
  console.warn("<TeaserContent> is deprecated. Use <CardContent> instead.");
  return <CardContent {...props} />;
}
